import React from 'react';

const Tooltip = (props) => {
  return (
    <div className="tooltip">?<div className="tooltip-text" dangerouslySetInnerHTML={{ __html: props.text }}/></div>
  );
};

export default Tooltip;
